function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Icon from '../icon';
var prefixCls = 'eui-pagination';
/*
  组件的state是否完全由组件自己控制
  是则不关心props变化
  否则关心props变化, 根据props变化重新设置自己的state, 进而改变视图
*/

var isHandleSelf = function isHandleSelf(currentPage) {
  return currentPage === undefined;
};

var Pagination = /*#__PURE__*/function (_React$Component) {
  _inherits(Pagination, _React$Component);

  var _super = _createSuper(Pagination);

  function Pagination(props) {
    var _this;

    _classCallCheck(this, Pagination);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "changePage", function (currentPage) {
      var _this$props = _this.props,
          onCurrentChange = _this$props.onCurrentChange,
          pageSize = _this$props.pageSize,
          total = _this$props.total,
          propsCurrentPage = _this$props.currentPage;
      var pageNum = Math.ceil(total / pageSize);
      if (currentPage > pageNum || currentPage <= 0) return;

      if (isHandleSelf(propsCurrentPage)) {
        _this.setState({
          currentPage: currentPage
        });
      }

      onCurrentChange(currentPage);
    });

    _defineProperty(_assertThisInitialized(_this), "renderPages", function () {
      var _this$props2 = _this.props,
          pageSize = _this$props2.pageSize,
          total = _this$props2.total,
          maxPageNum = _this$props2.maxPageNum;
      var currentPage = _this.state.currentPage;
      var pageNum = Math.ceil(total / pageSize);
      var pages = [];
      var tmpNum = Math.floor(maxPageNum / 2); // 计算两个省略号之间的数字的起始number和终止number

      var startNum = currentPage - tmpNum;

      if (pageNum - currentPage < tmpNum + 1) {
        startNum -= tmpNum + 1 - (pageNum - currentPage);
      }

      if (startNum <= 1) startNum = 2;
      var endNum = startNum + tmpNum * 2;
      if (endNum >= pageNum) endNum = pageNum - 1;

      var _loop = function _loop(i) {
        if (i === 1 || i === pageNum || startNum <= i && i <= endNum) {
          var classes = classNames("".concat(prefixCls, "-item"), _defineProperty({}, "".concat(prefixCls, "-item-active"), Number(currentPage) === i)); // const mixWidth = i.toString().length - 2;
          // const width = 26 + ((mixWidth > 0) ? mixWidth * 10 : 0);

          pages.push( /*#__PURE__*/React.createElement("li", {
            className: classes,
            key: "currentPage-".concat(i),
            onClick: function onClick() {
              _this.changePage(i);
            }
          }, i));
        }
      };

      for (var i = 1; i <= pageNum; i++) {
        _loop(i);
      } // 左侧省略


      if (startNum - 1 > 1) {
        pages.splice(1, 0, /*#__PURE__*/React.createElement("li", {
          className: "".concat(prefixCls, "-item"),
          key: "currentPage-left",
          onClick: function onClick() {
            _this.changePage(1);
          }
        }, "..."));
      } // 右侧省略


      if (endNum + 1 < pageNum) {
        pages.splice(pages.length - 1, 0, /*#__PURE__*/React.createElement("li", {
          className: "".concat(prefixCls, "-item"),
          key: "currentPage-right",
          onClick: function onClick() {
            _this.changePage(pageNum);
          }
        }, "..."));
      } // 没有页数时


      if (!pages.length) {
        return /*#__PURE__*/React.createElement("li", {
          className: "".concat(prefixCls, "-item ").concat(prefixCls, "-item-active"),
          onClick: function onClick() {
            _this.changePage(1);
          }
        }, "1");
      }

      return pages;
    });

    var _currentPage = props.currentPage;
    _this.state = {
      currentPage: isHandleSelf(_currentPage) ? 1 : Number(_currentPage)
    };
    return _this;
  }

  _createClass(Pagination, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$props3 = this.props,
          pageSize = _this$props3.pageSize,
          total = _this$props3.total,
          currentPage = _this$props3.currentPage;

      if (nextProps.pageSize != pageSize || nextProps.total != total || nextProps.currentPage != currentPage) {
        this.setState({
          currentPage: isHandleSelf(nextProps.currentPage) ? 1 : Number(nextProps.currentPage)
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          className = _this$props4.className,
          propsCurrentPage = _this$props4.currentPage,
          onCurrentChange = _this$props4.onCurrentChange,
          pageSize = _this$props4.pageSize,
          maxPageNum = _this$props4.maxPageNum,
          total = _this$props4.total,
          other = _objectWithoutProperties(_this$props4, ["className", "currentPage", "onCurrentChange", "pageSize", "maxPageNum", "total"]);

      var currentPage = this.state.currentPage;
      var classes = classNames(prefixCls, className);
      return /*#__PURE__*/React.createElement("ul", _extends({
        className: classes
      }, other), /*#__PURE__*/React.createElement("li", {
        className: "".concat(prefixCls, "-item ").concat(currentPage === 1 ? 'disabled' : ''),
        onClick: function onClick() {
          _this2.changePage(currentPage - 1);
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        value: "arrow-left"
      })), this.renderPages(), /*#__PURE__*/React.createElement("li", {
        className: "".concat(prefixCls, "-item ").concat(currentPage === total / pageSize ? 'disabled' : ''),
        onClick: function onClick() {
          _this2.changePage(currentPage + 1);
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        value: "arrow-right"
      })));
    }
  }]);

  return Pagination;
}(React.Component);

_defineProperty(Pagination, "defaultProps", {
  currentPage: undefined,
  onCurrentChange: function onCurrentChange() {},
  maxPageNum: 5
});

_defineProperty(Pagination, "propTypes", {
  total: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  currentPage: PropTypes.number,
  onCurrentChange: PropTypes.func,
  maxPageNum: PropTypes.number
});

export default Pagination;